enum ResourceSorting {
  ByName = 'ByName',
  ByEditDate = 'ByEditDate',
}

export default ResourceSorting;
